const getCurrentDateMs = () => Math.floor(new Date().getTime() / 1000);

export const hasWebSubscriptionExpired = (userAccount) => userAccount.subscription.cancel_at_period_end && getCurrentDateMs() > userAccount.subscription.cancel_at;